import React from "react";
import { Table, Row, Col } from "react-bootstrap";
import Thead from "./thead";
import Colgroup from "./colgroup";
import Tbody from "./tbody";
import Searcher from "./searcher";
import PageSizer from "./sizer";
import Pagination from "./pagination";

class FeraTable extends React.Component {
    /**
     *
     */
    constructor(props) {
        super(props);
        this.search = "";
    }

    onSearch = (e) => {
        this.search = e;
        if (!this.props.searchOnEnter) this.props.onSearch(e);
    }

    onSearchKeyEnter = (e) => {
        if ((e.key === "Enter") && (this.props.searchOnEnter)) {
            this.props.onSearch(this.search);
        }
    }

    get rows() {
        return Array.isArray(this.props.page) ? this.props.page : [];
    }

    get hasActiveSearch() {
        return String(this.props.search || this.search || "").trim().length > 0;
    }

    get totalCount() {
        const explicit = [this.props.totalCount, this.props.total, this.props.count]
            .map((value) => Number(value))
            .find((value) => Number.isFinite(value));
        if (Number.isFinite(explicit)) return explicit;

        const pages = Number(this.props.pages || 0);
        if (pages > 1) return 10;
        return this.rows.length;
    }

    get compactControls() {
        if (this.props.compactControls === false) return false;
        return !this.hasActiveSearch && this.totalCount < 10;
    }

    render() {
        const showSearch = Boolean(this.props.searchable) && !this.compactControls;
        const showSizer = Boolean(this.props.sizable) && !this.compactControls;

        return (
            <>
                {showSearch || showSizer ?
                    <Row className="mb-3 mt-3">
                        {showSearch ?
                            <Col sm="12" md="5" lg="3" xxl="2">
                                <div className="d-inline-block float-md-start me-1 mb-1 mb-md-0 search-input-container w-100 shadow bg-foreground">
                                    <Searcher onKeyDown={this.onSearchKeyEnter} onChange={this.onSearch} search={this.props.search} />
                                </div>
                            </Col>
                            : null}
                        {showSizer ?
                            <Col sm="12" md="7" lg="9" xxl="10" className="text-end">
                                <div className="d-inline-block">
                                    <PageSizer onChange={this.props.onSize} size={this.props.size} />
                                </div>
                            </Col>
                            : null}
                    </Row>
                    : null}
                {this.props.filter ?
                    {...this.props.filter}
                : null}
                <Row>
                    <Col xs="12">
                        <Table className={this.props.className || 'react-table boxed'} role="table">
                            <Colgroup headers={this.props.headers} />
                            <Thead headers={this.props.headers} onColumnClick={this.props.onColumnClick} sort={this.props.sort} />
                            <Tbody headers={this.props.headers} page={this.props.page} />
                        </Table>
                    </Col>
                    <Col xs="12">
                        <Pagination index={this.props.index} count={this.props.pages} onChange={ this.props.onPageChange } />
                    </Col>
                </Row>
            </>
        )
    }
}

export default FeraTable;
